export default __webpack_public_path__ + "static/media/1.e47f9ecf.png";